import { createStreamBuffer } from "../primitives/createStreamBuffer.ts";
import type { MetricSnapshot } from "@houston/shared";

/**
 * Per-metric streaming buffers, lazily allocated. Sparkline / uPlot
 * panels read from here so they get full history rather than the
 * single latest value that lives in the metrics store.
 */
const buffers = new Map<string, ReturnType<typeof createStreamBuffer>>();
const CAPACITY = 256;

export function getOrCreateBuffer(key: string) {
  let buf = buffers.get(key);
  if (!buf) {
    buf = createStreamBuffer(CAPACITY);
    buffers.set(key, buf);
  }
  return buf;
}

export function pushMetric(snap: MetricSnapshot) {
  const key = `${snap.source}:${snap.metric}`;
  getOrCreateBuffer(key).push(snap.timestamp, snap.value);
}
